// extracted by mini-css-extract-plugin
module.exports = {"buttons":"UserVideo_buttons__2-Vxj","empty":"UserVideo_empty__fy63j"};